// TotalInventoryShortage Getters

export const getTotalInventoryShortageList = state => {
  return state.totalInventoryShortageList
}

export const getTotalInventoryShortageCount = state => {
  return state.totalInventoryShortageCount
}
